module.exports = __webpack_public_path__ + "static/media/fk.8833fb78.svg";